import {DateTime} from 'luxon';



export default function formatTime (input) {
    return DateTime.fromISO(input).toLocaleString(DateTime.DATETIME_MED);
}